// Modo prueba del bot: mientras está encendido, el bot solo responde a los números de prueba del negocio y los demás chats quedan
// para una persona. Se guarda en businesses.bot_modo_prueba y businesses.numeros_prueba (migración 20261005b_bot_test_mode.sql);
// el flujo de n8n decide con esas dos columnas (nodo «Verificar Bot Activo»). Un negocio sin la opción responde a todos, como siempre.

export const MAX_TEST_NUMBERS = 10;

const digitsOf = (v) => String(v ?? '').replace(/\D/g, '');

// Lo que escribe la persona → número completo solo con dígitos (indicativo incluido), o null si no es un número válido.
// Un número local (hasta 10 dígitos) que no empieza por el indicativo elegido lo lleva por delante; la base exige de 10 a 15 dígitos.
export const normalizeTestNumber = (input, prefix = '57') => {
  const d = digitsOf(input).replace(/^0+/, '');
  if (!d) return null;
  const p = digitsOf(prefix);
  const full = p && d.length <= 10 && !d.startsWith(p) ? `${p}${d}` : d;
  return /^[0-9]{10,15}$/.test(full) ? full : null;
};

// Dos números son el mismo si coinciden sus últimos 10 dígitos (con o sin indicativo), como en el flujo del bot.
export const sameNumber = (a, b) => {
  const x = digitsOf(a).slice(-10);
  const y = digitsOf(b).slice(-10);
  return x.length >= 10 && x === y;
};

export const testNumbersOf = (business) => (Array.isArray(business?.numeros_prueba) ? business.numeros_prueba.map(String) : []);

// 'pausado' (el bot está apagado para todos), 'prueba' (solo responde a los números de prueba) o 'activo' (responde a todos).
export const botMode = (business) => {
  if (!business) return 'activo';
  if (business.bot_activo === false) return 'pausado';
  return business.bot_modo_prueba === true ? 'prueba' : 'activo';
};

// Agrega un número a la lista validándolo: devuelve { list } o { error } en español para mostrar tal cual.
export const addTestNumber = (list, input, prefix = '57') => {
  const current = Array.isArray(list) ? list : [];
  const n = normalizeTestNumber(input, prefix);
  if (!n) return { error: 'Escribe un número de celular válido (de 10 a 15 dígitos con el indicativo del país).' };
  if (current.some((x) => sameNumber(x, n))) return { error: 'Ese número ya está en la lista de prueba.' };
  if (current.length >= MAX_TEST_NUMBERS) return { error: `Puedes tener hasta ${MAX_TEST_NUMBERS} números de prueba.` };
  return { list: [...current, n] };
};

export const removeTestNumber = (list, number) => (Array.isArray(list) ? list : []).filter((x) => x !== number);

// +57 301 686 7636 → para mostrar en pantalla
export const prettyNumber = (n) => {
  const d = digitsOf(n);
  if (d.length === 12 && d.startsWith('57')) return `+57 ${d.slice(2, 5)} ${d.slice(5, 8)} ${d.slice(8)}`;
  return d ? `+${d}` : '';
};

// Un negocio nuevo arranca en modo prueba (el dueño lo enciende para todos cuando termine de afinarlo), con su propio celular de prueba si lo dio.
// Nunca falla: si la migración aún no está o la base no responde, el negocio queda como siempre (responde a todos) y el dueño puede activar el modo a mano.
export const startInTestMode = async (client, businessId, ownerPhone) => {
  try {
    const own = normalizeTestNumber(ownerPhone);
    const { error } = await client.from('businesses').update({ bot_modo_prueba: true, numeros_prueba: own ? [own] : [] }).eq('id', businessId);
    return !error;
  } catch {
    return false;
  }
};
